import { JSX } from 'react';

/**
 * Detects the type of a given URL, specifically checking for Google Maps, Zoom, and Google Meet links.
 *
 * @param url
 * @param format - 'react' returns a JSX anchor element; 'html' returns an HTML anchor string
 * @returns
 */
export const detectLinkType = (
  url: string,
  format?: 'react' | 'html',
): string | JSX.Element | null => {
  // 1. Google Maps
  const mapsRegex = /^https?:\/\/(www\.)?(google\.com\/maps|maps\.google\.com)\//i;

  // 2. Zoom
  const zoomRegex = /^https?:\/\/(.+\.)?zoom\.us\/(j|s|w)\//i;

  // 3. Google Meet
  const meetRegex = /^https?:\/\/(meet\.google\.com|g\.co\/meet)\//i;

  let name: string | null = null;

  if (mapsRegex.test(url)) {
    name = 'Google Maps';
  }
  if (zoomRegex.test(url)) {
    name = 'Zoom';
  }
  if (meetRegex.test(url)) {
    name = 'Google Meet';
  }

  if (format && name) {
    if (format === 'react') {
      return (
        <a href={url} target='_blank' rel='noopener noreferrer'>
          {name}
        </a>
      );
    } else if (format === 'html') {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${name}</a>`;
    }
  }

  return name; // Return null if no known link type is detected
};
